"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partition = exports.Node = exports.Network = exports.Describe = void 0;
const encoding_1 = require("../encoding");
const config_1 = require("./config");
const protocol = __importStar(require("./protocol"));
class Describe {
    constructor(args) {
        this.networkType =
            args.networkType == undefined
                ? undefined
                : protocol.PartitionType.fromObject(args.networkType);
        this.partitionId = args.partitionId == undefined ? undefined : args.partitionId;
        this.network =
            args.network == undefined
                ? undefined
                : args.network instanceof Network
                    ? args.network
                    : new Network(args.network);
    }
    copy() {
        return new Describe(this.asObject());
    }
    asObject() {
        return {
            networkType: this.networkType && protocol.PartitionType.getName(this.networkType),
            partitionId: this.partitionId && this.partitionId,
            network: this.network && this.network.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).enum
], Describe.prototype, "networkType", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], Describe.prototype, "partitionId", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], Describe.prototype, "network", void 0);
exports.Describe = Describe;
class Network {
    constructor(args) {
        this.id = args.id == undefined ? undefined : args.id;
    }
    copy() {
        return new Network(this.asObject());
    }
    asObject() {
        return {
            id: this.id && this.id,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], Network.prototype, "id", void 0);
exports.Network = Network;
class Node {
    constructor(args) {
        this.address = args.address == undefined ? undefined : args.address;
        this.type = args.type == undefined ? undefined : config_1.NodeType.fromObject(args.type);
    }
    copy() {
        return new Node(this.asObject());
    }
    asObject() {
        return {
            address: this.address && this.address,
            type: this.type && config_1.NodeType.getName(this.type),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], Node.prototype, "address", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], Node.prototype, "type", void 0);
exports.Node = Node;
class Partition {
    constructor(args) {
        this.id = args.id == undefined ? undefined : args.id;
        this.type = args.type == undefined ? undefined : protocol.PartitionType.fromObject(args.type);
        this.basePort = args.basePort == undefined ? undefined : args.basePort;
        this.nodes =
            args.nodes == undefined
                ? undefined
                : args.nodes.map((v) => (v == undefined ? undefined : v instanceof Node ? v : new Node(v)));
    }
    copy() {
        return new Partition(this.asObject());
    }
    asObject() {
        return {
            id: this.id && this.id,
            type: this.type && protocol.PartitionType.getName(this.type),
            basePort: this.basePort && this.basePort,
            nodes: this.nodes && this.nodes?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], Partition.prototype, "id", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], Partition.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(3).int
], Partition.prototype, "basePort", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], Partition.prototype, "nodes", void 0);
exports.Partition = Partition;
//# sourceMappingURL=config_types_gen.js.map